import { Search } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Kbd } from "@/components/ui/kbd"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { AppBreadcrumbs } from "@/components/layout/app-breadcrumbs"
import { useCommandMenu } from "@/components/layout/command-menu"
import { ThemeToggle } from "@/components/layout/theme-toggle"

export function AppHeader() {
  const { setOpen } = useCommandMenu()

  return (
    <header className="flex min-h-14 shrink-0 items-center gap-2 border-b px-3 pt-safe sm:px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mx-1 data-[orientation=vertical]:h-4" />
      <div className="min-w-0 flex-1">
        <AppBreadcrumbs />
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="h-8 gap-2 px-2 font-normal text-muted-foreground shadow-none sm:w-56 sm:justify-start sm:px-3 lg:w-64"
        aria-label="Open command palette"
      >
        <Search />
        <span className="hidden sm:inline">Search…</span>
        <Kbd className="ml-auto hidden border bg-background sm:inline-flex">⌘K</Kbd>
      </Button>
      <ThemeToggle />
    </header>
  )
}
